<div class="p-d-flex p-flex-column p-ai-stretch " [style.height]="'100%'">
	<div class="p-sidebar-content p-mt-3">

		<div *ngIf="inputProject !== null && inputProject !== undefined">
			<div class="p-fluid">
				<div class="p-field" *ngIf="inputProject.id !== null">
					<label>ProjectID</label>
					<input type="text" pInputText disabled [(ngModel)]="inputProject.id">
				</div>
				<div class="p-field">
					<label>Naam</label>
					<input type="text" pInputText required [(ngModel)]="inputProject.name">
				</div>
				<div class="p-field">
					<label>Divisiecode (zie divisies in Irias Auth)</label>
					<input type="text" pInputText required [(ngModel)]="inputProject.division_code">
				</div>

				<div class="p-mb-4" *ngIf="inputProject.id !== null">
					<ng-container *ngTemplateOutlet="config"></ng-container>
				</div>
			</div>
			<div class="p-d-flex p-jc-between">
				<button pButton pRipple type="button" class="p-button-danger p-button-rounded p-button-outlined"
						[label]="inputProject.id === null ? 'Annuleer' : 'Verwijder project'"
						(click)="discardProject()"></button>

				<button pButton pRipple type="button" label="Opslaan" (click)="submit()"
						icon="fa fa-save" class="p-button-success p-button-rounded"></button>
			</div>
		</div>
	</div>
</div>

<ng-template #config>
	<h3>Configuratie:</h3>
	<div class="p-mb-1"></div>
	<div class="p-mb-2"></div>
	<div class="p-field">
		<label>Frontend portaal - configuratie</label>
		<p style="font-size:xx-small;">
			Geef per module aan of deze getoond mag worden in de portal.
		</p>
	</div>
	<div class="p-field">
		<label>Toon flexvervoer-module in portal:</label>
		<p-toggleButton  onLabel="Ja" onIcon="fa fa-check" offLabel="Nee" offIcon="fa fa-times" [(ngModel)]="inputProject.config.flexModuleConfig.showModule"></p-toggleButton>
	</div>
	<div class="p-field p-mt-2">
		<label>Toon gebruikersmodule:</label>
		<p-toggleButton onLabel="Ja" offLabel="Nee" onIcon="fa fa-check" offIcon="fa fa-times"
						[(ngModel)]="inputProject.config.usersModuleConfig.showModule"></p-toggleButton>
	</div>

	<h2>Thema-config:</h2>
	<div class="p-field p-mt-2">
		<label>Primary-color:</label>
		<input type="text" pInputText [(ngModel)]="inputProject.config.themeConfig.primaryColor">
	</div>
	<div class="p-field p-mt-2">
		<label>Primary-color-text:</label>
		<input type="text" pInputText [(ngModel)]="inputProject.config.themeConfig.primaryColorText">
	</div>
	<div class="p-field p-mt-2">
		<label>Logo-bestand: (laat leeg voor OVIT-logo)</label>
		<input type="text" pInputText [(ngModel)]="inputProject.config.logo">
	</div>
</ng-template>